<template>
  <p
    v-if="error"
    class="cf-input-error"
  >
    {{ error }}
  </p>
</template>



<script>
  export default {
    name: 'CfInputError',

    props: {
      error: {
        type: String,
        default: null
      }
    }
  };
</script>
